export default __webpack_public_path__ + "static/B2B-award_2023-24dab1967845e7a78bbc1878dcd9a1c3.png";